<template>
  <div class="homeSpace">
    <div class="menusSpace" style="height:100%">
      <el-row  >
        <el-col :span="18"  :style="comWidth?'width:'+comWidth+'px;':''" >
          <el-row v-if="selectMenus==1" >
            <el-row class="rowArtTitle" style="border-radius:4px;">
              <el-col :span="3" class="firstTitle">TA的文章</el-col>
              <el-col :span="1" class="fontViewMore" style="text-align:left;" >
                <span class="iconNumber"><label>{{this.articleCount}}</label></span>
              </el-col>
            </el-row>
            <div class="articles">
              <div class="articleContent">
                <div :comWidth="comWidth">
                  <ArticleV v-for="(a,index) in articleList" :articleItem="a" :key="index" :linkFrom="caogaoxiang" @submit-loadPage="loadPage" style="padding-bottom: 20px;"/>
                </div>
              </div>
            </div>
            <el-row class="rowArtTitle" style="margin-top:0px;padding-top:25px">
              <el-col :span="3" class="firstTitle">TA的作品</el-col>
              <el-col :span="1" class="fontViewMore" style="text-align:left;" >
                <span class="iconNumber"><label>{{this.worksCount}}</label></span>
              </el-col>
            </el-row>
            <div class="workStyle" :style="comWidth?'width:'+comWidth+'px;':'padding:0px 0 0 8px'" >
              <div class="bujuStyle" :style="comWidth?'width:'+(comWidth)+'px;padding-top:4px':'padding-top:4px'"  >
               
                  <Works  v-for="(a,index) in worksList" :worksItem="a" :key="index" style=" width: 159px;height: 159px;margin-right:20px;margin-bottom: 35px;"   :collection="comWidth" :linkFrom="caogaoxiang"/>
                
              </div>
            </div>
            <el-row class="rowArtTitle" style="margin-top:0px;padding-top:25px">
              <el-col :span="3" class="firstTitle">TA的视频</el-col>
              <el-col :span="1" class="fontViewMore" style="text-align:left;" >
                <span class="iconNumber"><label>{{this.videoCount}}</label></span>
              </el-col>
            </el-row>
            <div class="videos" :style="comWidth?'width:'+comWidth+'px;':''" >
              <div class="videoContent" :style="comWidth?'width:'+(comWidth-39)+'px;':''">
               
                  <VideoV v-for="(a,index) in videoList" :videoItem="a" :key="index" style="margin-bottom: 75px;margin-right:20px;;" :linkFrom="caogaoxiang" :comWidth="205" :comHeight="115" />
                
              </div>
          </div>
            <el-row class="rowArtTitle" style="margin-top:0px;padding-top:25px">
              <el-col :span="3" class="firstTitle">TA的问答</el-col>
              <el-col :span="1" class="fontViewMore" style="text-align:left;" >
                <span class="iconNumber"><label>{{this.qaCount}}</label></span>
              </el-col>
            </el-row>
            <div class="answerQuestion" :style="comWidth?'width:'+comWidth+'px;':''">
              <div class="answerContent" :style="comWidth?'width:'+comWidth+'px;padding-left:20px;':'padding-left:20px;'" >
                <QuestionsC v-for="(a,index) in qaList" :qaItem="a" :key="index" :style="index==0?'margin-top:-10px':''" :linkFrom="caogaoxiang" />
              </div>
            </div>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>


import AnswerV from '@/components/AnswerV.vue'
import ArticleV from '@/components/SpaceArticle.vue'
import PublishArt from '@/components/userCenter/SpacePublishArt.vue'
import Works from '@/components/userCenter/Works.vue'
import VideoV from '@/components/VideoV.vue'
import QuestionsC from '@/components/userCenter/QuestionsC.vue'

import {queryArticleList,queryVideoList,queryWorksList,queryQaList} from '@/comm/api'
import Vue from "vue";

export default {
  name: 'Home',
  components: {
    QuestionsC,
    ArticleV,
    AnswerV,
    PublishArt,
    Works,
    VideoV
  },
    props: {
    comWidth:{
      type:Number,
      default:null,
    },
    linkFrom:{
      //标明数据来源：该页面个人空间、创作中心首页、草稿箱共用
      type:String,
      default:null,
    },
  },
  data() {
    return {
      categaries : [{text:'Maya',value:'1'}],
      selectMenus:1,
      comWidth:215,
      comHeight:120,
      linkFrom:'space',
      selectIndex:0,
      selectType:0,
      selectWorksIndex:0,
      selectVideoIndex:0,
      selectAnswerIndex:0,
      viewIndex:1,
      articleList:[],
      articleCount:0,
      videoList: [],
      videoCount:0,
      worksList:[],
      worksCount:0,
      qaList:[],
      qaCount:0
    }
  },
  created(){
    this.loadPage();
  },
  methods:{
    loadPage(){
      this.loadArticle();
      this.loadVideo();
      this.loadWork();
      this.loadQa();
    },
    //文章
    loadArticle(){
      queryArticleList({"pageNo":1,"pageSize":999,"createBy":Vue.ls.get("UserInfo").id,"status":4,"orderBy":this.viewIndex}).then((res)=>{
          if(res.success){
            this.articleList = res.result.records;
            this.articleCount = res.result.total;
          }else{
            console.log(res.message);
          }
        });
    },
    loadVideo(){
      queryVideoList({ "pageNo":1,"pageSize":999,"createBy":Vue.ls.get("UserInfo").id,"status":4,"orderBy":this.viewIndex }).then((res) => {
          if (res.success) {
            this.videoList = res.result.records;
            this.videoCount = res.result.total;
          } else {
            console.log(res.message);
          }
        });
    },
    loadWork(){
      queryWorksList({"pageNo":1,"pageSize":999,"createBy":Vue.ls.get("UserInfo").id,"status":4,"orderBy":this.viewIndex}).then((res) => {
        if (res.success) {
          
          this.worksList = res.result.records;
          this.worksCount = res.result.total;
        } else {
          console.log(res.message);
        }
      });
    },
    loadQa(){
      queryQaList({ "pageNo":1,"pageSize":999,"createBy":Vue.ls.get("UserInfo").id,"status":4,"orderBy":8 }).then(res => {
        if (res.success) {
          this.qaList = res.result.records;
          this.qaCount = res.result.total;
        } else {
          console.log(res.message);
        }
      });
    },
    selectData(type,index){
      this.selectType=type;
      if(type == 0){
        this.selectIndex = index;
        this.viewIndex = index;
        this.loadArticle();
      }else if(type == 1){
        this.selectWorksIndex = index;
      }else if(type == 2){
        this.selectVideoIndex = index;
      }else{
        this.selectAnswerIndex = index;
      }

    },
    goCollectionInfo(url){
      this.$router.push(url);
    },
    chooseMenus(index){
      this.selectMenus = index;
    },
    format(percentage) {
        // return percentage === 100 ? '满' : `${percentage}%`;
        return '';
      },

  },
}
</script>
<style lang="stylus" scoped>

.homeSpace{
  width 100%;
  height :100%;

  background-color #F3F3F5;

  font-family: PingFangSC-Semibold, PingFang SC;

  .flex-center{
    display flex;
    align-items center;
  }
  .menusSpace{
    width 1200px;
    height 400px;
    // background-color white;
    margin: 0 auto;
    // display: flex;
    // justify-content: space-between;

    .mainStyle{
        background-color :#fff;
        width :186 px;
        margin-top:20px;
    }
    .fontTitle{
        text-align: left;
        height: 25px;
        font-size: 16px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #ffffff;
        line-height: 24px;
      }
    .fontTime{
      margin-top:7px;
      text-align: left;
      height: 17px;
      font-size: 13px;
      font-family: MicrosoftYaHei;
      color: #ffffff;
      line-height: 17px;
    }
    .searchStyle{
      background-color :#ffffff;
      height:72px;

    }
    .banner{
      width:1200px;
      height:203px;
      background-image :url("https://ns-strategy.cdn.bcebos.com/ns-strategy/upload/fc_big_pic/part-00622-1582.jpg");
    }
    .buttonStyle{
      margin:18px 20px 0 0;
      float:right;
      background-color:#F72B17;
      width:80px;
      height:36px;
      color:#fff;
    }
    .workStyle{
      width:900px;
      background:#fff;
      padding-bottom:30px;
      border-bottom: 1px solid #EEEEEE;
      .bujuStyle{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        width:863px;
        margin:0 auto;
        background :#fff;
        .worksStyle{
          width: 20%;
          height :210px;
          text-align : -webkit-center;
        }

      }
    }
    .videos{
      padding-bottom:30px;
      border-bottom: 1px solid #EEEEEE;
      padding-top:16px;
      width 900px;
      background :#fff;
      .videoContent{
        width 100%;
        margin 0 auto;
        border-radius 4px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .worksStyle{
          width: 25%;
          height :210px;

        }
      }
    }
   .rowArtTitle{
     margin:0px 0 0 0;
     background-color :#fff;
     padding:20px 0 ;
    //  border-bottom: solid 1px #e6e6e6;
     .fontViewMore{
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
      text-align :right;
      padding-top: 3px;
    }
    .fontArt{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0F0F0F;
      line-height: 20px;
      padding-left:20px;
    }
    .selectStyle{
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 17px;
    }
    .select{

        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #F72B17;
        border-bottom :1px solid #F72B17;
        padding-bottom:2px;
        line-height: 17px;
      }
    .iconNumber{
      line-height :25px;
      background: url("../../assets/icons/xinxikuang.png") no-repeat;
      background-size :100% 100%;
      label{
        margin-left:4px;
        padding: 0px 5px;
      }
    }

   }
   .articles{
     margin-top 0px;
     background :#fff;
      .articleContent{
        margin: 0 auto;
        // display:flex;
        // justify-content space-between;
        // flex-wrap:wrap;
        font-family:none;
        .fengexian{
            padding-bottom 10px;border-bottom: 1px solid #EEEEEE;
            width :592px;

        }
        .fengexianLong{
            padding-bottom 25 px;border-bottom: 1px solid #EEEEEE;
            width :100%;
        }
      }
   }
   .answerQuestion{
       width:900px;
       background :#fff;
      .answerContent{

        display :flex;
        justify-content :space-between;
        margin:0 auto;
        flex-wrap:wrap;
      }
   }
  }

}
.rightMenus{
  // background :#fff;

  width:25%;
  padding-left:10px
  .renzhengStyle{
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 40px;
        // height:43px;
        padding:12px 0 0 15px;
        .content{
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 5px;
          display :block;
          padding-left:20px;
        }
        .title{
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 17px;
        }
  }
}

</style>
